// extracted by mini-css-extract-plugin
export default {"account_form":"verificationForm_account_form__mJVXh","button":"verificationForm_button__Lm+1K"};